import React from 'react'
import VaccinationPlan from './VaccinationPlan'
import { connect } from 'react-redux'

class VaccinationPlanContainer extends React.Component {
  render () {
    return <VaccinationPlan locale={this.props.locale} />
  }
}

function mapStateToProps ({polyglot}) {
  return {
    locale: polyglot.locale
  }
}

export default connect(mapStateToProps)(VaccinationPlanContainer)
